import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
const variantClasses = {
    neutral: 'bg-ax-graphite text-ax-text-secondary border-ax-line',
    aurora: 'bg-[rgba(229,165,71,0.10)] text-ax-aurora border-[rgba(229,165,71,0.30)]',
    plasma: 'bg-[rgba(110,91,255,0.12)] text-ax-plasma border-[rgba(110,91,255,0.30)]',
    electric: 'bg-[rgba(0,229,192,0.10)] text-ax-electric border-[rgba(0,229,192,0.30)]',
    critical: 'bg-[rgba(255,92,92,0.10)] text-ax-critical border-[rgba(255,92,92,0.35)]',
    warning: 'bg-[rgba(245,166,35,0.10)] text-ax-warning border-[rgba(245,166,35,0.30)]',
    // "Auditável · N fontes verificadas" — selo signature da plataforma
    auditable: 'bg-ax-gradient-signature-soft text-ax-aurora border-[rgba(229,165,71,0.40)]',
};
export function Badge({ variant = 'neutral', icon, uppercase = true, className, children, ...rest }) {
    return (_jsxs("span", { className: cn('inline-flex items-center gap-1.5 px-2 py-0.5 rounded-ax-pill border', 'font-mono text-[10px] font-medium tracking-wider', uppercase && 'uppercase', variantClasses[variant], className), ...rest, children: [icon && _jsx("span", { className: "flex items-center", "aria-hidden": "true", children: icon }), children] }));
}
//# sourceMappingURL=Badge.js.map